import * as React from "react";
import classNames from "classnames";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";

import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";

export interface InfobarProps {
	rootClass?: string;
	visible: boolean;
	renderSaveButton: boolean;
	zIndex: number;
	children: React.ReactNode;
	contentClass?: string;
	onSaveClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	onCancelClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

type Props = InfobarProps & WithStyles<typeof styles>;

export class Infobar extends React.Component<Props, {}> {
	static defaultProps: Partial<InfobarProps> = {
		onSaveClick: () => {},
		onCancelClick: () => {}
	};

	render() {
		const {
			classes,
			children,
			visible,
			zIndex,
			renderSaveButton,
			onSaveClick,
			onCancelClick,
			contentClass,
			rootClass
		} = this.props;

		return (
			<div
				className={classNames(classes.root, rootClass, {
					[classes.rootVisible]: visible
				})}
				style={{
					zIndex
				}}
			>
				<div className={classNames(classes.content, contentClass)}>
					{children}
				</div>
				<div className={classes.buttonContainer}>
					{renderSaveButton && (
						<IconButton
							className={classes.button}
							onClick={onSaveClick}
							style={{
								borderBottom: "1px solid lightgray",
								borderRadius: 0
							}}
						>
							<DoneIcon className={classes.buttonIcon} />
						</IconButton>
					)}
					<IconButton
						className={classes.button}
						onClick={onCancelClick}
					>
						<CloseIcon className={classes.buttonIcon} />
					</IconButton>
				</div>
			</div>
		);
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			background: "#EBEEF1",
			boxShadow: "0 0 8px rgba(0, 0, 0, 0.2)",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			transform: "translate3d(0, -110%, 0)",
			transition: "transform 0.4s ease"
		},
		rootVisible: {
			transform: "translate3d(0, 0, 0)!important"
		},
		content: {
			padding: theme.spacing.unit * 2,
			flexGrow: 1
		},
		buttonContainer: {
			flexGrow: 0,
			marginLeft: 15,
			borderLeft: "1px solid lightgray",
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			height: "100%",
			background: "#E5E8EB"
		},
		button: {
			display: "block"
		},
		buttonIcon: {
			fontSize: 32
		}
	});

export const ConnectedInfobar = withStyles(styles)(Infobar);
